<div class="confirm-popup-wr d-flex flex-column justify-content-center align-items-center p-4">

  <h2 class="text-center mb-0 text-uppercase font-bold">{{data.title}}</h2>
  <p class="d-block m-0 py-3 text-center">{{data.message}}</p>

  <div class="d-flex flex-row justify-content-center mt-2">
      <button mat-flat-button mat-dialog-close class="btn primary me-2">{{data.cancelTxt}}</button>
      <button mat-flat-button class="btn danger" (click)="confirm()">{{data.confirmTxt}}</button>
  </div>
</div>